import { ModalsModule } from '../../../widgets/entry-components/modal/modals.module';
import { PractitionerAddComponent } from './practitioner-add.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { PatientPipesModule } from '../../patient/pipes/patient-pipes.module';

@NgModule({
  declarations: [PractitionerAddComponent],
  imports: [
    PatientPipesModule,
    CommonModule, IonicModule, FormsModule, ReactiveFormsModule, ModalsModule, TranslateModule
  ],
  exports: [PractitionerAddComponent]
})
export class PractitionerAddModule { }
